import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutIEEE from './components/AboutIEEE';
import StudentBranch from './components/StudentBranch';
import AboutESPOCH from './components/AboutESPOCH';
import Chapters from './components/Chapters';
import Events from './components/Events';
import Benefits from './components/Benefits';
import Team from './components/Team';
import Gallery from './components/Gallery';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const handlePointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
    const x = (event.clientX / window.innerWidth - 0.5) * 24;
    const y = (event.clientY / window.innerHeight - 0.5) * 24;
    document.documentElement.style.setProperty('--pointer-x', `${x}px`);
    document.documentElement.style.setProperty('--pointer-y', `${y}px`);
  };

  return (
    <div onPointerMove={handlePointerMove} className="relative min-h-screen bg-white text-slate-900 overflow-x-hidden">
      {/* Global Animated Background Elements */}
      <div className="global-bg">
        <div className="global-bg-layer"></div>
      </div>
      <div className="particles-container"></div>

      <Navbar />
      <main className="relative z-10">
        <Hero />
        <AboutIEEE />
        <StudentBranch />
        <AboutESPOCH />
        <Chapters />
        <Benefits />
        <Team />
        <Gallery />
        <Events />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
